import { createSelector } from 'reselect';
import { getThemeSettingsValues, getThemeFields } from 'ContentData/selectors/themeSettings';
import { getBrandSettings } from 'ContentData/selectors/branding';
export const getInheritanceData = createSelector([getThemeSettingsValues, getThemeFields, getBrandSettings], (themeSettings, themeFields, brandSettings) => ({
  brandSettings,
  themeFields,
  themeSettings
}));